<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <b-card-group deck>
        <b-card
          bg-variant="primary"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'primary',
          }"
          style="cursor: pointer"
          @click="goToProducts()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    productNumber.number
                  }}</b-badge>
                </h2>
                <b-card-text>
                  تعداد کل اقلام
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="4">
              <h3 class="text-left">
                <i class="fa fa-object-ungroup"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>

        <b-card
          bg-variant="success"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'success',
          }"
          style="cursor: pointer"
          @click="goToSections()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    sectionNumber.number
                  }}</b-badge>
                </h2>
                <b-card-text>
                  تعداد کل بخش‌های انبار
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols>
              <h3 class="text-left">
                <i class="fa fa-hourglass"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card> </b-card-group
    ></v-col>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";

export default {
  data: function () {
    return {
      guide: false,

      productNumber: [],
      sectionNumber: [],
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    goToSections() {
      this.$router.push("/warehouse/allWarehouses");
    },
    goToProducts() {
      this.$router.push("/warehouse/products");
    },
    numberOfProducts() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/productNumber",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.productNumber = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    numberOfSections() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/sectionNumber",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.sectionNumber = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },

  mounted() {
    this.numberOfProducts();
    this.numberOfSections();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
